import "core-js/modules/es6.object.assign";
import { useHighlight } from '@docpocalypse/code-live';
import theme from '@docpocalypse/code-live/themes/ultramin';
import React from 'react';
export function InlineHighlight(_ref) {
  var code = _ref.code;

  var _useHighlight = useHighlight({
    theme: theme,
    code: code,
    language: 'tsx'
  }),
      tokens = _useHighlight.tokens,
      getTokenProps = _useHighlight.getTokenProps;

  return /*#__PURE__*/React.createElement(React.Fragment, null, tokens.map(function (line, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(React.Fragment, {
        key: i
      }, line.map(function (token, ii) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement("span", Object.assign({
            key: ii
          }, getTokenProps({
            token: token,
            key: String(ii)
          })))
        );
      }))
    );
  }));
}